import { useMemo } from 'react';

import { theme } from '~/theme';

export const useSxStyles = () => {
  return useMemo(() => {
    return {
      root: {
        display: 'inline',
        '& .unit-number': {
          fontSize: '0.8em',
          color: theme.palette.text.secondary,
          '&.default': {
            display: 'block',
          },
          '&.inline': {
            '&:before': {
              content: '"("',
            },
            '&:after': {
              content: '")"',
            },
          },
        },
      },
    };
  }, []);
};
